import React, { Component } from 'react'
import './Contacts.css';
import LayoutWrapper from '../../component/LayoutWrapper/'
import Footer from '../../component/Footer/Footer';
import {formContact, doContactFormRes} from '../../action/ContactUsFormAction';
import { compose } from 'redux';
import { connect } from 'react-redux';
import { createStructuredSelector } from 'reselect';
import PropTypes from 'prop-types';
import ReactGA from 'react-ga';
import ReactPixel from 'react-facebook-pixel';


var pattern = /^[+a-zA-Z0-9._-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,6}$/i;

class Contacts extends Component {
    constructor() {
        super();
        this.state = {
            // isLoader: false,
            isSubmited: false,
            contactName: '',
            email: '',
            subject: '',
            description : '',
        }
        ReactGA.initialize('UA-64201999-5');
        ReactGA.pageview(window.location.pathname + window.location.search);

        ReactPixel.init('784849368913134');

        ReactPixel.pageView();
    }

    validate(values) {
        const errors = {};  
        if(values.contactName && values.contactName.trim() === ''){
            errors.contactName = '*Please enter name';
        }else if(values.contactName === null){
        errors.contactName = '*Please enter name';
        }else if(values.contactName === undefined){
        errors.contactName = '*Please enter name';
        }else if(values.contactName === ''){
        errors.contactName = '*Please enter name';
        }      
        
        if (values.email && values.email === '') {
            errors.email = '*Please enter emailid';
        }else if (values.email && values.email.trim() === '') {
          errors.email = '*Please enter emailid';
        }else if(values.email === undefined){
            errors.email = '*Please enter emailid';
        }else if (!pattern.test(values.email)) {
            errors.email = "*Please enter valid email address.";
        }
    
        if(values.subject && values.subject.trim() === ''){
          errors.subject = '*Please enter subject';
        }else if(values.subject === null){
          errors.subject = '*Please enter subject';
        }else if(values.subject === undefined){
          errors.subject = '*Please enter subject';
        }else if(values.subject === ''){
          errors.subject = '*Please enter subject';
        }   
        
        if(values.description && values.description.trim() === ''){
            errors.description = '*Please enter description';
          }else if(values.description === null){
            errors.description = '*Please enter description';
          }else if(values.description === undefined){
            errors.description = '*Please enter description';
          }else if(values.description === ''){
            errors.description = '*Please enter description';
          } 
        return errors;      
    }

    contactSubmit = e =>{
        e.preventDefault();
        this.setState({
            isSubmited: true,        
        }, () => { });
        this.validate(this.state);
        const errors = this.validate(this.state);
        if (Object.keys(errors).length === 0) { 
            let requestData = {
                contactName : this.state.contactName,
                email : this.state.email,
                subject: this.state.subject,
                description: this.state.description
            }
            this.setState({
                // isLoader: true
            })
            this.props.formContact(requestData)
        }

    }

    componentWillReceiveProps(nextProps){
        if(nextProps.doContactFormRes && nextProps.doContactFormRes.user){
            if(nextProps.doContactFormRes.user && nextProps.doContactFormRes.user.contactFormRes){
                if(nextProps.doContactFormRes.user.contactFormRes && nextProps.doContactFormRes.user.contactFormRes.result === true){
                    this.setState({
                        contactName: '',
                        email: '',
                        subject: '',
                        description : '',
                    })
                }else{
                    this.setState({
                        contactName: '',
                        email: '',
                        subject: '',
                        description : '',
                    })
                }
            }
        }
    }


    render() {
        const errors = this.validate(this.state);
        const {isSubmited} = this.state;

        return (
            <React.Fragment>
                <LayoutWrapper />

                <main className="main main-container">
                    <nav aria-label="breadcrumb" className="breadcrumb-nav">
                        <div className="container">
                            <ol className="breadcrumb">
                                <li className="breadcrumb-item"><a href="/">Home</a></li>
                                <li className="breadcrumb-item active" aria-current="page">Contact Us</li>
                            </ol>
                        </div>
                        {/* End .container */}
                    </nav>
                    <div className="page-header">
                        <div className="container">
                            <h1>Contact Us</h1>
                        </div>
                        {/* End .container */}
                    </div>
                    {/* End .page-header */}
                    <div className="container">
                        {/* <div id="map"></div> */}
                        {/* End #map */}
                        <div className="row">
                            <div className="col-md-8">
                                <h2 className="light-title">Write <strong>Us</strong></h2>
                                <form onSubmit = {this.contactSubmit}>
                                    <div className="form-group required-field">
                                        <label htmlFor="contact-name">Name</label>
                                        <input type="text" className="form-control" id="contact-name" name="contactName" autoComplete="off" onChange = {(e) => this.setState({contactName: e.target.value})} value = {this.state.contactName} />
                                        {errors && isSubmited && <span className="error-message msg">{errors.contactName}</span>}
                                    </div>
                                    {/* End .form-group */}
                                    <div className="form-group required-field">
                                        <label htmlFor="contact-email">Email</label>
                                        <input type="email" autoComplete="off" className="form-control" id="contact-email" name="email" onChange = {(e) => this.setState({email: e.target.value})} value = {this.state.email} />
                                        {errors && isSubmited && <span className="error-message msg">{errors.email}</span>}
                                    </div>
                                    {/* End .form-group */}
                                    <div className="form-group required-field">
                                        <label htmlFor="contact-subject">Subject</label>
                                        <input type="text" autoComplete="off" className="form-control" id="contact-subject" name="subject" onChange = {(e) => this.setState({subject: e.target.value})} value = {this.state.subject} />
                                        {errors && isSubmited && <span className="error-message msg">{errors.subject}</span>}
                                    </div>
                                    {/* End .form-group */}
                                    <div className="form-group required-field">
                                        <label htmlFor="contact-message">Your Message</label>
                                        <textarea cols="30" rows="1" id="contact-message" className="form-control textAreaSize" name="description" autoComplete="off" onChange = {(e) => this.setState({description: e.target.value})} value = {this.state.description} ></textarea>
                                        {errors && isSubmited && <span className="error-message msg">{errors.description }</span>}
                                    </div>
                                    {/* End .form-group */}
                                    <div className="form-footer">
                                        <button type="submit" className="btn btn-primary show-color" >Submit</button>
                                    </div>
                                    {/* End .form-footer */}
                                </form>
                            </div>
                            {/* End .col-md-8 */}
                            <div className="col-md-4">
                                <h2 className="light-title">Contact <strong>Details</strong></h2>
                                <div className="contact-info">
                                    {/* <div>
                                        <i className="icon-phone"></i>
                                        <p><a href="tel:">0201 203 2032</a></p>
                                        <p><a href="tel:">0201 203 2032</a></p>
                                    </div>
                                    <div>
                                        <i className="icon-mobile"></i>
                                        <p><a href="tel:">201-123-3922</a></p>
                                        <p><a href="tel:">302-123-3928</a></p>
                                    </div> */}
                                    <div>
                                        <i className="icon-mail-alt"></i>
                                        <p><a href="mailto:support@stylecabbie.com">support@stylecabbie.com</a></p>
                                    </div>
                                    {/* <div>
                                        <i className="icon-skype"></i>
                                        <p>porto_skype</p>
                                        <p>porto_template</p>
                                    </div> */}
                                </div>
                                {/* End .contact-info */}
                            </div>
                            {/* End .col-md-4 */}
                        </div>
                        {/* End .row */}
                    </div>
                    {/* End .container */}
                    <div className="mb-8"></div>
                    {/* margin */}
                </main>
                {/* End .main */}

                <Footer />

            </React.Fragment>
        )
    }
}

Contacts.propTypes = {
    doContactFormRes: PropTypes.any, 
};

const mapStateToProps = createStructuredSelector({
    doContactFormRes:  doContactFormRes,
});

function mapDispatchToProps(dispatch) {
    return {
       formContact: (data) => dispatch(formContact(data)),       
    };
}

const withConnect = connect(mapStateToProps, mapDispatchToProps);
export default  compose(withConnect)(Contacts)
